import { AuditState } from './audit-state.enum';
import { AuditType } from './audit-type.enum';

export class Audit {
  public id: string = '';
  public type: AuditType = AuditType.FiveS;
  public frequency: string = '';
  public location: string = '';
  public area: string = '';
  public site: string = '';
  public siteSection: string = '';
  public dueDate: Date = new Date();
  public state: AuditState = AuditState.NotStarted;
  public layoutId?: string;


  public constructor(init?:Partial<Audit>) {
    Object.assign(this, init);
  }
}
